import request from '@/utils/request'

export function getDataLuminaria (aap_id) {
  const data = {
    aap_id
  }
  return request({
    url: '/geo/lum/' + data.aap_id,
    method: 'get'
  })
}
